import { $createParagraphNode, $createTextNode, $getRoot } from "lexical";

/**
 * Serialises the editor content to a plain string. Calls each top-level node's
 * `getTextContent()`, which custom nodes override to emit their own textual
 * form — decorators for merge tag chips, block nodes for product contexts and
 * blocks. Top-level nodes are joined with `\n`.
 *
 * For a paragraph of inline children Lexical's `ElementNode.getTextContent()`
 * is a plain concatenation, so this matches the hand-rolled join it replaced.
 *
 * Must be called inside `editor.read()` or `editor.update()`.
 */
export function $serializeEditorToPlainText(): string {
  return $getRoot()
    .getChildren()
    .map((child) => child.getTextContent())
    .join("\n");
}

/**
 * Replaces the editor content with paragraphs of plain text. Extension-
 * provided node transforms (e.g. merge tag auto-detect) run automatically
 * during the same update cycle, converting recognised `{{tag}}` patterns
 * into custom decorator nodes.
 *
 * Must be called inside `editor.update()`.
 */
export function $populateEditorFromPlainText(text: string): void {
  const root = $getRoot();
  root.clear();

  const lines = text.split("\n");
  for (const line of lines) {
    const paragraph = $createParagraphNode();
    if (line.length > 0) {
      paragraph.append($createTextNode(line));
    }
    root.append(paragraph);
  }
}
